import { DataProvider } from "react-admin";
import { ResourceName } from "../react-admin.util";
import { adminUsersResourceProvider } from "./admin-users.data-provider";
import { usersResourceProvider } from "./users.data-provider";
import { vettingUsersResourceProvider } from "./vetting-users.data-provider";
import { affiliateUsersResourceProvider } from "./affiliates-users.data-provider";
import { referralUsersResourceProvider } from "./referral-users.data-provider";
import { affiliatePayoutsResourceProvider } from "./affiliate-payouts.data-provider";
import { eventsResourceProvider } from "./events.data-provider";
import { userPurchasesResourceProvider } from "./user-purchases.data-provider";

export * from "./auth.data-provider";

const getDP = (resource: string) => {
  switch (resource as ResourceName) {
    case ResourceName.USERS: {
      return usersResourceProvider.dataProvider;
    }
    case ResourceName.ADMIN_USERS: {
      return adminUsersResourceProvider.dataProvider;
    }
    case ResourceName.VETTING_USERS: {
      return vettingUsersResourceProvider.dataProvider;
    }
    case ResourceName.AFFILIATE_USERS: {
      return affiliateUsersResourceProvider.dataProvider;
    }
    case ResourceName.AFFILIATE_PAYOUTS: {
      return affiliatePayoutsResourceProvider.dataProvider;
    }
    case ResourceName.REFERRAL_USERS: {
      return referralUsersResourceProvider.dataProvider;
    }
    case ResourceName.EVENTS: {
      return eventsResourceProvider.dataProvider;
    }
    case ResourceName.USER_PURCHASES: {
      return userPurchasesResourceProvider.dataProvider;
    }

    default: {
      throw new Error(`No data provider for resource: ${resource}`);
    }
  }
};

export const RaDataProvider: DataProvider = {
  getList: (r, params) => getDP(r).getList(r, params),
  getMany: (r, params) => getDP(r).getMany(r, params),
  getOne: (r, params) => getDP(r).getOne(r, params),
  create: (r, params) => getDP(r).create(r, params),
  update: (r, params) => getDP(r).update(r, params),
  updateMany: (r, params) => getDP(r).updateMany(r, params),
  delete: (r, params) => getDP(r).delete(r, params),
  deleteMany: (r, params) => getDP(r).deleteMany(r, params),
  getManyReference: (r, params) => getDP(r).getManyReference(r, params),
};
